import React, { useEffect, useRef, useState } from 'react';
import '../../components/profile-faqs/faq-profile.css';
import { useTranslation } from 'react-i18next';

declare global {
    interface Window {
        BodhiwellProfileFaq: any;
    }
}

interface ProfessionalFaqsPublicProps {
    faqs: any[];
    isOwnProfile?: boolean;
}

export const ProfessionalFaqsPublic: React.FC<ProfessionalFaqsPublicProps> = ({ faqs, isOwnProfile }) => {
    const faqContainerRef = useRef<HTMLDivElement>(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        const loadFaqs = async () => {
            if (!faqs || faqs.length === 0) {
                setLoading(false);
                return;
            }

            try {
                if (!window.BodhiwellProfileFaq) {
                    // @ts-ignore
                    await import('../../components/profile-faqs/faq-public.js');
                }

                if (faqContainerRef.current && window.BodhiwellProfileFaq) {
                    window.BodhiwellProfileFaq.init(faqContainerRef.current, faqs, {
                        showEditButton: isOwnProfile,
                        title: t('landing.professionalInfo.faqsTitle', 'Preguntas frecuentes'),
                        intro: t('landing.professionalInfo.faqsIntro', 'Información útil para conocer mejor las sesiones y la forma de trabajo.')
                    });
                }
            } catch (error) {
                console.error("Error loading public FAQs", error);
            } finally {
                setLoading(false);
            }
        };

        loadFaqs();
    }, [faqs]);

    if (!faqs || faqs.length === 0 || !faqs.some(f => f.isVisible)) {
        return null; // Don't render anything if no FAQs are visible
    }

    return (
        <>
            {loading && <p style={{ display: 'none' }}>{t('common.loading', 'Cargando...')}</p>}
            <div ref={faqContainerRef} style={{ display: loading ? 'none' : 'block' }}></div>
        </>
    );
};
